/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from "react"
import { iBasicQuery, iResponse } from "../../definitions/interfaces"
import { iUser } from "../../definitions/User"
import Table from "../../components/Table/Table"
import { RowInfo } from "react-table-6"
import { useHistory } from "react-router"
import AsyncSelectInput from "../../components/Form/Select/AsyncSelect"
import { get } from "../../store/data/actions"
import { iPackage } from "../../definitions/Package"
import s from "./Users.less"
import { Input } from "../../components/Form"

const tableData = [
  {
    Header: "Username",
    accessor: "username",
  },
  {
    id: "emails.address",
    Header: "Email",
    accessor: (d: any) => d.emails && d.emails[0] && d.emails[0].address,
  },
  {
    id: "profile.country",
    Header: "Country",
    accessor: (d: any) => d.profile && d.profile.country,
  },
  {
    id: "package.name",
    Header: "Package",
    accessor: (d: any) => d.package && d.package.name,
    // eslint-disable-next-line react/display-name
    Filter: ({ filter, onChange }: any) => {
      const loadPackages = async (input: string) => {
        try {
          const result = await get<iResponse<iPackage[]>>({
            link: "/v1/user-package-list",
            query: { name: input },
          })

          return result.data
        } catch (e) {
          console.error(e)
        }
      }

      return (
        <AsyncSelectInput
          value={filter ? filter.value : ""}
          onChange={onChange}
          defaultOptions
          loadOptions={loadPackages}
          isMulti={true}
          name="package.name"
          containerClassName={s.selectFilter}
          noPadding={true}
        />
      )
    },
  },
  {
    id: "package.isCustom",
    Header: "Custom package",
    accessor: "package.isCustom",
    sortable: false,
    // eslint-disable-next-line react/display-name
    Filter: ({ filter, onChange }: any) => {
      return (
        <Input
          name="package.isCustom"
          value={filter ? filter.value : false}
          onChange={(v) => {
            console.log(v)

            onChange(v)
          }}
          type="checkbox"
          label="Show only custom"
          containerClassName={s.inputContainer}
        />
      )
    },
  },
  {
    id: "createdAt",
    Header: "Created At",
    accessor: (d: any) => {
      return d.createdAt && new Date(d.createdAt).toDateString()
    },
  },
]

const defaultSorted = [
  {
    id: "emails.address",
    desc: false,
  },
]

const Users: FunctionComponent = () => {
  const history = useHistory()
  const onClick = (rowInfo: RowInfo) => {
    const { original } = rowInfo || {}

    if (original && original._id) {
      history.push("/users/" + original._id)
    }
  }

  return (
    <>
      <div className="content">
        <div className="content-header">
          <h1 className="text-center"> Users</h1>
        </div>
        <div className={`grid-wrap ${s.container}`}>
          <Table<iBasicQuery, iUser>
            link="/v2/users"
            columns={tableData}
            defaultSorted={defaultSorted}
            onClick={onClick}
          />
        </div>
      </div>
    </>
  )
}

export default Users
